import React from 'react';
import { Radio } from 'react-bootstrap';

const Company = ({ filter, styles }) => {
  const { header, body } = styles;
  return (
    <div>
      <div style={header || {}} className="filter-head">{filter.name}</div>
      <ul className="filter-inner-list">
        <li className=""><Radio style={body || {}} name="company">Walmart</Radio></li>
        <li className=""><Radio style={body || {}} name="company">Amazon</Radio></li>
        <li className=""><Radio style={body || {}} name="company">Microsoft</Radio></li>
        <li className=""><Radio style={body || {}} name="company">Facebook</Radio></li>
        <li className=""><Radio style={body || {}} name="company">Google</Radio></li>
        <li className=""><Radio style={body || {}} name="company">All</Radio></li>
      </ul>
    </div>
  );
};

export default Company;
